import React, { useEffect, useState } from 'react';
import StatusEnum from 'axios/enum';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import { APP_PATH } from 'config';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginAction } from 'reducer/common/login';
import { localStorageRetaierIdName } from 'consts';

interface IformData {
  accessToken: '';
  funcCode: '';
  userId: '';
  retailerId: '';
}

const AuthPage = () => {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoginRedux } = loginAction;
  const [formData, setFormData] = useState<IformData>({
    accessToken: '',
    funcCode: '',
    userId: '',
    retailerId: '',
  });
  const handleLogin = async () => {
    const response = await axios.doAxios(MethodEnum.post, '/token/login', {
      userId: formData.userId,
      securePwd: formData.accessToken,
    });
    if (response) {
      if (response.data.status === StatusEnum.完成) {
        // 體系別預設選項
        localStorage.setItem(localStorageRetaierIdName, formData.retailerId);
        dispatch(setLoginRedux(true));
        const url = `${APP_PATH}/${formData.funcCode}`;

        navigate(url);
      }
    }
  };

  useEffect(() => {
    if (window.name) {
      setFormData(JSON.parse(window.name));
    }
  }, [window.name]);

  useEffect(() => {
    if (formData && formData.userId) {
      console.log('formData=>', formData);
      handleLogin();
    }
  }, [formData]);

  return <>驗證頁3</>;
};
export default AuthPage;
